import React from 'react';

import classnames from 'classnames';

import { useSize } from '../../../features/config';
import { Skeleton, type SkeletonProps } from '../Skeleton';

import styles from '../Skeleton.module.scss';

import type { AvatarProps } from '../../Avatar/Avatar';

export type SkeletonAvatarProps = Omit<SkeletonProps, 'height' | 'width'> &
    Pick<AvatarProps, 'size' | 'shape' | 'customSize'>;

export const SkeletonAvatar = ({
    className,
    size: sizeProp,
    style,
    customSize,
    shape = 'circle',
    ...rest
}: SkeletonAvatarProps) => {
    const size = useSize(sizeProp, 'medium', 'SkeletonAvatar');
    const customSizeStyle = customSize ? { width: customSize, height: customSize } : {};

    return (
        <Skeleton
            {...rest}
            className={classnames(styles.avatar, styles[size], styles[shape], className)}
            style={{ ...customSizeStyle, ...style }}
            height={undefined}
            width={undefined}
        />
    );
};
